export default "__VITE_ASSET__CoD5kp6Q__"